export default {
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.requirement.message':
    'Please enter the Health Check name',
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.too_long.message':
    'Health Check name is too long',
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.already_exists.message':
    'Health Check name already exists',
  'service.create.service_status_check_table.description.paragraph1.fragment1':
    'Gremlin will work with your existing observability and monitoring tools. We recommend creating alerts and monitors based on the',
  'service.create.service_status_check_table.description.paragraph1.fragment2':
    '. Each Service will require their own set of Health Check monitors and alerts. However, once one team member authenticates, that authentication will be shared in',
  'service.create.service_status_check_table.description.paragraph1.fragment3':
    '. Learn how to add',
  'service.create.service_status_check_table.description.paragraph1.fragment4':
    'to your Service.',
  'service.create.service_status_check_table.description.paragraph2':
    'Once connected, your Health Check monitor will help Gremlin determine how well your Services are weathering Reliability Tests. When Gremlin sees your monitor alerting, Reliability Tests will be automatically halted for this Service.',
  'service.create.service_status_check_table.description.paragraph1.link1.label':
    'Health Checks',
  'service.create.service_status_check_table.description.paragraph1.link2.label':
    'Team Settings',
  'service.create.service_status_check_table.table.header.column1':
    'Health Check Name',
  'service.create.service_status_check_table.table.header.column2': 'Actions',
  'service.details.incomplete_service_guide.completed_section.status_check_added.title':
    'Health Check added',
  'service.details.incomplete_service_guide.getting_started.add_status_check.title':
    'Add a Health Check',
  'service.details.incomplete_service_guide.getting_started.add_status_check.paragraph':
    'Each of your services will need a Health Check to evaluate whether your Reliability Tests have passed or failed. Gremlin will work with your existing observability and monitoring tools to automatically halt tests that are causing your Service to fail. If you don’t have your monitors set up yet, we recommend setting up monitors that look at: latency, traffic, error rate, and resource saturation.',
  'service.incomplete.warning': 'To run Reliability Tests, add a Health Check',
  'service.details.incomplete_service_guide.getting_started.run_a_test.paragraph':
    'Pick a test below to run on your Service. Your Health Check will tell Gremlin whether a reliability test has passed or failed. It will also tell Gremlin when to halt the test, if necessary.',
  'service.incomplete.warning.scheduling':
    'To schedule Reliability Tests, add a Health Check',
  'service.reliability_test.in_progress':
    'A reliability test is in progress. Wait for it to finish before starting another reliability test.',
  'service.reliability_test.run_test.modal_title': 'Run {{name}} Test?',
  'service.reliability_test.run_test.in_production.modal_title':
    'Run {{name}} Test in Production?',
  'service.reliability_test.run_test.modal_content':
    "Your Service may be impacted. You can stop the test while it's in progress if needed.",
  'service.status.service_status_page.status_checks_info.paragraph':
    'Your Health Checks will continuously monitor your service and halt the test if unhealthy states are reported.',
  'service.status_header.reliability_test.results.expired':
    'This test expired on {{expiryDate}}. Run this test again to refresh the result.',
  'service.status_header.reliability_test.results.failed':
    'Your Health Checks observed unhealthy status codes while Gremlin was testing your system.',
  'service.status_header.reliability_test.results.halted':
    'There was a problem while Gremlin was testing. We recommend trying to run this test again.',
  'service.status_header.reliability_test.results.passed':
    'Your Health Checks observed healthy criteria while Gremlin was testing your system. This test result will expire on {{expiryDate}}',
  'service.status_header.reliability_test.results.user_halted':
    'A user halted this test while it was in progress. Run this test again, without halting, to get results.'
}
